import { AdjustmentNoteCategoryEnum, AdjustmentNoteStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { PurchaseProductsEntity } from "./purchases-product.entity";

@Entity("purchases")
export class PurchasesEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"purchase_id"
    }) 
    purchaseId: number;

    
    @Column('int',{
        name:'vendor_id',
        nullable:false
    })
    vendorId:number

    @Column('int',{
        name:'unit_id',
        nullable:false
    })
    unitId:number

    @Column('varchar',{
        name:'lot_number',
        nullable:false,
        length:50
    })
    lotNumber:string

    @Column('varchar',{
        name:'invoice_no',
        nullable:false,
        length:50
    })
    invoiceNumber:string

   
    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
        
    @Column('int',{
        name:'ref_no'
    })
    refNumber : number

    @OneToMany(type => PurchaseProductsEntity, e => e.purchasesInfo, { cascade: true })
    purchaseProductsInfo: PurchaseProductsEntity[];

}